
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Profile",
      function () {
        return require("private-next-pages/Profile.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Profile"])
      });
    }
  